"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var sysTempApi = _interopRequireWildcard(require("@/api/systemMessageTemplate"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var CHANNEL_NAME = {
  feishu: '飞书',
  sms: '短信',
  wechat: '微信',
  email: '邮箱'
};
function makeChannel(code) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return {
    channelCode: code,
    content: '',
    extra: '',
    enabled: enabled,
    priority: 0
  };
}
var DEFAULT_CHANNEL_LIST = function DEFAULT_CHANNEL_LIST() {
  return [makeChannel('feishu'), makeChannel('sms'), makeChannel('wechat'), makeChannel('email')];
};
var _default = exports.default = {
  components: {
    draggable: _vuedraggable.default
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      isEdit: false,
      activeTab: 'feishu',
      pram: this.initParam(),
      channelList: DEFAULT_CHANNEL_LIST(),
      variables: {},
      variableList: [],
      adminList: [],
      alertLevelList: [],
      rules: {
        templateKey: [{
          required: true,
          message: '请填写模板KEY',
          trigger: 'blur'
        }],
        templateName: [{
          required: true,
          message: '请填写模板名称',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.loadVariables();
    this.loadAdminList();
    this.loadAlertLevels();
  },
  methods: {
    initParam: function initParam() {
      return {
        id: null,
        templateKey: '',
        templateName: '',
        description: '',
        alertLevel: '',
        status: 1
      };
    },
    loadVariables: function loadVariables() {
      var _this = this;
      return sysTempApi.getAvailableVariables().then(function (res) {
        _this.variables = res || {};
        _this.variableList = Object.entries(_this.variables || {}).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            name = _ref2[1];
          return {
            key: key,
            name: name
          };
        });
      });
    },
    loadAdminList: function loadAdminList() {
      var _this2 = this;
      return sysTempApi.getAdminList().then(function (res) {
        _this2.adminList = res || [];
      });
    },
    loadAlertLevels: function loadAlertLevels() {
      var _this3 = this;
      return sysTempApi.getAlertLevels().then(function (res) {
        _this3.alertLevelList = res || [];
      });
    },
    getChannelName: function getChannelName(code) {
      return CHANNEL_NAME[code] || code;
    },
    getChannel: function getChannel(code) {
      return this.channelList.find(function (c) {
        return c.channelCode === code;
      }) || this.channelList[0];
    },
    getExtra: function getExtra(channel) {
      if (!channel.extra) return {};
      try {
        return JSON.parse(channel.extra);
      } catch (e) {
        return {};
      }
    },
    setExtra: function setExtra(channel, key, value) {
      var obj = this.getExtra(channel);
      if (value === '' || value === null || value === undefined) {
        delete obj[key];
      } else {
        obj[key] = value;
      }
      channel.extra = Object.keys(obj).length > 0 ? JSON.stringify(obj) : '';
    },
    // 飞书字段
    getTitle: function getTitle(channel) {
      return this.getExtra(channel).title || '';
    },
    setTitle: function setTitle(channel, val) {
      this.setExtra(channel, 'title', val);
    },
    getType: function getType(channel) {
      return this.getExtra(channel).type || 'group';
    },
    setType: function setType(channel, val) {
      this.setExtra(channel, 'type', val);
    },
    getWebhook: function getWebhook(channel) {
      return this.getExtra(channel).webhook || '';
    },
    setWebhook: function setWebhook(channel, val) {
      this.setExtra(channel, 'webhook', val);
    },
    getAdminIds: function getAdminIds(channel) {
      return this.getExtra(channel).adminIds || [];
    },
    setAdminIds: function setAdminIds(channel, val) {
      this.setExtra(channel, 'adminIds', val || []);
    },
    // 短信字段
    getSmsAdminIds: function getSmsAdminIds(channel) {
      return this.getExtra(channel).smsAdminIds || [];
    },
    setSmsAdminIds: function setSmsAdminIds(channel, val) {
      this.setExtra(channel, 'smsAdminIds', val || []);
    },
    getSmsOtherPhones: function getSmsOtherPhones(channel) {
      var extra = this.getExtra(channel);
      // 兼容历史版本保存的 smsOtherPhones 字段
      return extra.otherPhones || extra.smsOtherPhones || '';
    },
    setSmsOtherPhones: function setSmsOtherPhones(channel, val) {
      this.setExtra(channel, 'otherPhones', val);
    },
    getSmsProvider: function getSmsProvider(channel) {
      return this.getExtra(channel).provider || 'TENCENT';
    },
    setSmsProvider: function setSmsProvider(channel, val) {
      this.setExtra(channel, 'provider', val || 'TENCENT');
    },
    getSmsTencentTemplateCode: function getSmsTencentTemplateCode(channel) {
      var extra = this.getExtra(channel);
      return extra.tencentTemplateCode || '';
    },
    setSmsTencentTemplateCode: function setSmsTencentTemplateCode(channel, val) {
      var extra = this.getExtra(channel);
      if (val === '' || val === null || val === undefined) delete extra.tencentTemplateCode;else extra.tencentTemplateCode = val;
      channel.extra = Object.keys(extra).length > 0 ? JSON.stringify(extra) : '';
    },
    getSmsAliyunTemplateCode: function getSmsAliyunTemplateCode(channel) {
      return this.getExtra(channel).aliyunTemplateCode || '';
    },
    setSmsAliyunTemplateCode: function setSmsAliyunTemplateCode(channel, val) {
      this.setExtra(channel, 'aliyunTemplateCode', val);
    },
    getSmsAliyunTemplateContent: function getSmsAliyunTemplateContent(channel) {
      return this.getExtra(channel).aliyunTemplateContent || '';
    },
    setSmsAliyunTemplateContent: function setSmsAliyunTemplateContent(channel, val) {
      this.setExtra(channel, 'aliyunTemplateContent', val);
    },
    appendAliyunVariable: function appendAliyunVariable(channel, variableCode) {
      var content = this.getSmsAliyunTemplateContent(channel);
      this.setSmsAliyunTemplateContent(channel, "".concat(content, "${").concat(variableCode, "}"));
    },
    // 微信字段
    getWechatNames: function getWechatNames(channel) {
      return this.getExtra(channel).wechatNames || '';
    },
    setWechatNames: function setWechatNames(channel, val) {
      this.setExtra(channel, 'wechatNames', val);
    },
    getWechatGroupNames: function getWechatGroupNames(channel) {
      return this.getExtra(channel).wechatGroupNames || '';
    },
    setWechatGroupNames: function setWechatGroupNames(channel, val) {
      this.setExtra(channel, 'wechatGroupNames', val);
    },
    // 邮箱字段
    getEmailSubject: function getEmailSubject(channel) {
      return this.getExtra(channel).emailSubject || '';
    },
    setEmailSubject: function setEmailSubject(channel, val) {
      this.setExtra(channel, 'emailSubject', val);
    },
    getEmailNotifyUsers: function getEmailNotifyUsers(channel) {
      return this.getExtra(channel).emailNotifyUsers || '';
    },
    setEmailNotifyUsers: function setEmailNotifyUsers(channel, val) {
      this.setExtra(channel, 'emailNotifyUsers', val);
    },
    openInit: function () {
      var _openInit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        var detail, firstEnabledChannel;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.pram = this.initParam();
              this.channelList = DEFAULT_CHANNEL_LIST();
              this.activeTab = 'feishu';
              this.isEdit = !!row;
              _context.n = 1;
              return Promise.all([this.loadVariables(), this.loadAdminList(), this.loadAlertLevels()]);
            case 1:
              if (!row) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return sysTempApi.getSystemTemplateDetail(row.id);
            case 2:
              detail = _context.v;
              this.pram.id = detail.id;
              this.pram.templateKey = detail.templateKey;
              this.pram.templateName = detail.templateName;
              this.pram.description = detail.description;
              this.pram.alertLevel = detail.alertLevel || '';
              this.pram.status = detail.status;
              if (detail.channels && detail.channels.length > 0) {
                this.channelList = detail.channels.map(function (c) {
                  var ch = makeChannel(c.channelCode, c.enabled);
                  ch.id = c.id;
                  ch.content = c.content || '';
                  ch.priority = c.priority || 0;
                  ch.extra = c.extra || '';
                  return ch;
                });
              }
              firstEnabledChannel = this.channelList.find(function (channel) {
                return channel.enabled === 1;
              });
              this.activeTab = (firstEnabledChannel || this.channelList[0]).channelCode;
            case 3:
              this.visible = true;
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function openInit(_x) {
        return _openInit.apply(this, arguments);
      }
      return openInit;
    }(),
    appendVariable: function appendVariable(channel, varKey) {
      var varText = "{".concat(varKey, "}");
      var ref = this.$refs["textarea_".concat(channel.channelCode)];
      var textarea = ref && ref.$el ? ref.$el.querySelector('textarea') : null;
      if (textarea) {
        var start = textarea.selectionStart;
        var end = textarea.selectionEnd;
        var cur = channel.content || '';
        channel.content = cur.slice(0, start) + varText + cur.slice(end);
        this.$nextTick(function () {
          var pos = start + varText.length;
          textarea.focus();
          textarea.setSelectionRange(pos, pos);
        });
      } else {
        channel.content = (channel.content || '') + varText;
      }
    },
    onTabSortStart: function onTabSortStart() {},
    onTabSortEnd: function onTabSortEnd() {},
    onEnabledChange: function onEnabledChange(channel) {
      this.activeTab = channel.channelCode;
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    handerSubmit: function handerSubmit() {
      var _this4 = this;
      this.$refs['formRef'].validate(function (valid) {
        if (!valid) return;
        var enabledChannels = _this4.channelList.filter(function (c) {
          return c.enabled === 1;
        });
        if (enabledChannels.length === 0) {
          _this4.$message.warning('请至少启用一个通知渠道');
          return;
        }
        var emptyChannels = enabledChannels.filter(function (c) {
          if (c.channelCode !== 'sms') return !(c.content || '').trim();
          var extra = _this4.getExtra(c);
          var provider = extra.provider || 'TENCENT';
          var selectedContent = provider === 'ALIYUN' ? extra.aliyunTemplateContent : c.content;
          return !(selectedContent || '').trim();
        });
        if (emptyChannels.length > 0) {
          _this4.$message.warning("\u542F\u7528\u7684\u6E20\u9053\u3010".concat(emptyChannels.map(function (c) {
            return CHANNEL_NAME[c.channelCode];
          }).join('、'), "\u3011\u6A21\u677F\u5185\u5BB9\u4E3A\u7A7A\uFF0C\u8BF7\u586B\u5199\u540E\u518D\u4FDD\u5B58"));
          return;
        }
        var smsChannel = _this4.channelList.find(function (c) {
          return c.channelCode === 'sms';
        });
        if (smsChannel && smsChannel.enabled === 1) {
          var smsExtra = _this4.getExtra(smsChannel);
          var provider = smsExtra.provider || 'TENCENT';
          var selectedCode = provider === 'ALIYUN' ? smsExtra.aliyunTemplateCode : smsExtra.tencentTemplateCode;
          if (!(selectedCode || '').trim()) {
            _this4.$message.warning(provider === 'ALIYUN' ? '请填写阿里云短信模板Code' : '请填写腾讯云短信模板Code');
            return;
          }
        }
        _this4.loading = true;
        var submitChannels = _this4.channelList.map(function (c) {
          return {
            id: c.id || null,
            channelCode: c.channelCode,
            content: c.content,
            extra: c.extra,
            enabled: c.enabled
          };
        });
        var submitData = _objectSpread(_objectSpread({}, _this4.pram), {}, {
          channelList: submitChannels
        });
        var api = _this4.isEdit ? sysTempApi.updateSystemTemplate : sysTempApi.createSystemTemplate;
        api(submitData).then(function () {
          _this4.$message.success(_this4.isEdit ? '编辑成功' : '新增成功');
          _this4.visible = false;
          _this4.loading = false;
          _this4.$emit('doRefresh');
        }).catch(function () {
          _this4.loading = false;
        });
      });
    }
  }
};